var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotebook01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 12.8333V9.16659C20.1665 5.70962 20.1665 3.98114 19.0926 2.90719C18.0186 1.83325 16.2901 1.83325 12.8332 1.83325H10.9998C7.54287 1.83325 5.81439 1.83325 4.74045 2.90719C3.6665 3.98114 3.6665 5.70962 3.6665 9.16659V12.8333C3.6665 16.2902 3.6665 18.0187 4.74045 19.0926C5.81439 20.1666 7.54287 20.1666 10.9998 20.1666H12.8332C16.2901 20.1666 18.0186 20.1666 19.0926 19.0926C20.1665 18.0187 20.1665 16.2902 20.1665 12.8333Z",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8035 9.16667H13.9463C14.9341 9.16667 15.4279 9.16667 15.7347 8.89818C16.0416 8.6297 16.0416 8.19758 16.0416 7.33333C16.0416 6.46909 16.0416 6.03697 15.7347 5.76849C15.4279 5.5 14.9341 5.5 13.9463 5.5H10.8035C9.81579 5.5 9.32193 5.5 9.01509 5.76849C8.70825 6.03697 8.70825 6.46909 8.70825 7.33333C8.70825 8.19758 8.70825 8.6297 9.01509 8.89818C9.32193 9.16667 9.81579 9.16667 10.8035 9.16667Z",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 5.5L1.83325 5.5M4.58325 11H1.83325M4.58325 16.5H1.83325",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook01);
export default __webpack_public_path__ + "static/media/notebook-01.2e0f05d83f405b7414c9948f75942278.svg";
export { ForwardRef as ReactComponent };